/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum XpertMtbRifResult {
    MTB_NOT_DETECTED = 'mtbNotDetected',
    DETECTED_RIF_SENSITIVE = 'detectedRifSensitive',
    DETECTED_RIF_RESISTANT = 'detectedRifResistant',
    DETECTED_RIF_INDETERMINATE = 'detectedRifIndeterminate',
    INVALID = 'invalid',
}
